/* VB · avatares de opiniones (snippets/vb-avatars.liquid) · QA 27-oct
   1) Rotación: cada ~4,5 s una cara visible se cambia por otra del pool que no esté a la vista (fundido de .8 s),
      solo si el grupo se ve en pantalla, la pestaña está activa y no hay «reducir movimiento».
   2) Ola: con el ratón encima del grupo, cada círculo sube y baja por separado con retraso escalonado (90 ms) y se
      repite mientras siga el cursor; al salir termina su recorrido (sin saltos). Nada en táctil. */
(() => {
  if (window.__vbAvatars) return;
  window.__vbAvatars = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const ROTATE_MS = 4500;
  const shuffle = (a) => { for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; } return a; };

  const init = (root) => {
    if (root.__vbAv) return;
    root.__vbAv = true;
    const items = [...root.querySelectorAll('.vb-avatars__item')];
    if (!items.length) return;
    let pool = root.__vbAvPool;
    if (!pool) { try { pool = JSON.parse(root.querySelector('[data-vb-avatars-pool]').textContent); } catch (e) { pool = []; } }
    const shown = () => items.map((it) => it.querySelector('.vb-avatars__img:last-child')?.getAttribute('src'));

    // --- Rotación ---------------------------------------------------------------------------------------------
    let inView = false, timer = 0, lastSlot = -1, busy = false;
    const visible = () => inView && !document.hidden && (!root.checkVisibility || root.checkVisibility({ visibilityProperty: true, opacityProperty: true }));
    const swap = () => {
      if (busy || reduce.matches || !visible()) return;
      const now = shown();
      const free = shuffle(pool.filter((u) => !now.includes(u)));
      if (!free.length) return;
      let slot = Math.floor(Math.random() * items.length);
      if (items.length > 1 && slot === lastSlot) slot = (slot + 1 + Math.floor(Math.random() * (items.length - 1))) % items.length;
      lastSlot = slot;
      const item = items[slot];
      const old = item.querySelector('.vb-avatars__img:last-child');
      const img = old.cloneNode(false);
      img.removeAttribute('loading');
      img.classList.add('is-in');
      img.src = free[0];
      busy = true;
      const done = () => {
        item.appendChild(img);
        requestAnimationFrame(() => requestAnimationFrame(() => img.classList.remove('is-in')));
        setTimeout(() => { item.querySelectorAll('.vb-avatars__img').forEach((n) => { if (n !== img) n.remove(); }); busy = false; }, 900);
      };
      (img.decode ? img.decode() : Promise.resolve()).then(done, () => { busy = false; });
    };
    const start = () => { if (!timer && pool.length > items.length && !reduce.matches) timer = setInterval(swap, ROTATE_MS + Math.round(Math.random() * 900)); };
    const stop = () => { clearInterval(timer); timer = 0; };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { inView = e.isIntersecting; inView ? start() : stop(); }).observe(root);
    } else { inView = true; start(); }

    // --- Ola al pasar el ratón -------------------------------------------------------------------------------
    let over = false, waving = false;
    const STEP = 90, DUR = 900;
    const frames = [
      { transform: 'translateY(0) scale(1)', easing: 'cubic-bezier(.22, 1, .36, 1)' },
      { transform: 'translateY(-7px) scale(1.06)', offset: .38, easing: 'cubic-bezier(.45, 0, .55, 1)' },
      { transform: 'translateY(1px) scale(.99)', offset: .72, easing: 'cubic-bezier(.45, 0, .55, 1)' },
      { transform: 'translateY(0) scale(1)' }
    ];
    const wave = () => {
      if (waving || reduce.matches || !items[0].animate) return;
      waving = true;
      root.classList.add('is-waving');
      const anims = items.map((it, i) => it.animate(frames, { duration: DUR, delay: i * STEP, fill: 'none' }));
      anims[anims.length - 1].finished.catch(() => {}).then(() => {
        waving = false;
        if (over) setTimeout(() => { if (over) wave(); else root.classList.remove('is-waving'); }, 260);
        else root.classList.remove('is-waving');
      });
    };
    root.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'mouse' || !hover.matches) return; over = true; wave(); });
    root.addEventListener('pointerleave', () => { over = false; });
  };

  const run = (scope = document) => scope.querySelectorAll('[data-vb-avatars]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
